'use client';

import React, { useEffect, useRef } from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';

const stats = [
{ value: '11', label: 'Signature Scents' },
{ value: '2,400+', label: '5-Star Reviews' },
{ value: '98%', label: 'Satisfaction Rate' },
{ value: '100%', label: 'Handcrafted in Small Batches' }];


export default function BrandStorySection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.reveal-hidden').forEach((el, i) => {
              setTimeout(() => el.classList.remove('reveal-hidden'), i * 100);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef?.current) observer?.observe(sectionRef?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-16 md:py-24 bg-secondary">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left image — 5 cols */}
          <div className="reveal reveal-hidden lg:col-span-5 relative">
            <div className="aspect-[4/5] overflow-hidden card-rounded">
              <AppImage
                src="/assets/images/template/rocket_gen_img_146247ef4-1772484895633.webp"
                alt="Elegant woman applying luxury skincare in bright airy bathroom, clean natural light, white and marble tones"
                fill
                sizes="(max-width: 1024px) 100vw, 42vw"
                className="object-cover product-card-img" />
              
            </div>
            {/* Floating accent card */}
            <div className="absolute -bottom-6 -right-4 md:-right-8 glass-card p-6 card-rounded shadow-xl max-w-[200px]">
              <p className="font-display text-3xl font-light text-foreground">4.9★</p>
              <p className="text-[11px] text-muted-foreground mt-1">Average customer rating across all products</p>
            </div>
          </div>

          {/* Right content — 7 cols */}
          <div className="lg:col-span-7 flex flex-col justify-between gap-10">
            <div className="reveal reveal-hidden">
              <span className="section-label block mb-4">Our Philosophy</span>
              <h2 className="font-display text-4xl md:text-5xl font-light tracking-tight text-foreground leading-tight mb-6">
                Beauty is a ritual,<br />
                <em className="font-light text-accent">not a routine.</em>
              </h2>
              <p className="text-base text-muted-foreground leading-relaxed max-w-lg">
                SweetSkyn by Kym was founded on the belief that every person deserves access to transformative beauty. We curate only the finest formulas — those that deliver real results with luxurious textures that make the daily ritual something you look forward to.
              </p>
              <Link
                href="/products"
                className="inline-flex items-center gap-3 mt-8 px-8 py-4 bg-primary text-primary-foreground text-xs font-semibold uppercase tracking-widest hover:bg-accent hover:text-accent-foreground transition-all duration-300">
                
                Discover Our Edit
              </Link>
            </div>

            {/* Stats grid */}
            <div className="reveal reveal-hidden grid grid-cols-2 gap-6 pt-6 border-t border-border">
              {stats?.map((stat) =>
              <div key={stat?.label}>
                  <p className="font-display text-3xl md:text-4xl font-light text-foreground">{stat?.value}</p>
                  <p className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground mt-1">{stat?.label}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>);

}